import { render, staticRenderFns } from "./menu-topbar.component.vue?vue&type=template&id=6a61d320&scoped=true&"
import script from "./menu-topbar.component.vue?vue&type=script&lang=ts&"
export * from "./menu-topbar.component.vue?vue&type=script&lang=ts&"
import style0 from "./menu-topbar.component.vue?vue&type=style&index=0&id=6a61d320&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a61d320",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VNavigationDrawer,VRow})
